import React, { useContext } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";

// utils
import { dateFormat2, getDwk, isEmpty, timeFormat } from "bodycodi/cmap/app/js/common";

const CommunityListCardMembers = ({ details }: any) => {
  const { dispatch } = useContext(DispatchContext);

  const imageList = details.members.map((d: any, i: number) => {
    const imgUrl = isEmpty(d.imageUrl) ? empty : d.imageUrl;

    if (i < 2) {
      return (
        <div className="profile" key={i}>
          <img src={imgUrl} />
        </div>
      );
    }
  });

  const nameList = details.members.map((member: any, index: number) => {
    return <span key={index}>{member.name}님</span>;
  });

  const clickMember = (e: any) => {
    e.stopPropagation();
    dispatch({ type: "UPDATE", data: { showCommunityMemberList: details.members } });
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_MEMBER_LIST_POP",
      open: { comunityMemberListPop: true },
    });
  };

  const dateType = () => {
    const date = details.regDt.split("T")[0];
    const time = details.regDt.split("T")[1];

    const dwk = getDwk(new Date(date).getDay());
    const timeText = timeFormat(time.substring(0, 5));

    return `${dateFormat2({ date: date })} ${dwk} &middot; ${timeText.ampm} ${timeText.time}`;
  };

  return (
    <div className="profile-wrap">
      <div className="profile-list-wrap" onClick={clickMember}>
        <div className="profile-list">{imageList}</div>
        {details.members.length > 2 && <div className="more">+{details.members.length - 1}</div>}
      </div>
      <div className="profile-info">
        <div className="name">
          {details.members.length <= 2 && nameList}
          {details.members.length > 2 && (
            <span>
              {details.members[0].name}님 외 {details.members.length - 1}명
            </span>
          )}
        </div>
        <div className="date" dangerouslySetInnerHTML={{ __html: dateType() }}></div>
      </div>
    </div>
  );
};

export default CommunityListCardMembers;
